import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class SealApplyApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'sealApply'
  }

}